"use strict";

const { getCssPrefix } = require("@runtime/runner/legacy-features");
var PyDefUtils = require("PyDefUtils");

module.exports = function(pyModule) {

	pyModule["DesignLink"] = Sk.misceval.buildClass(pyModule, ($gbl, $loc) => {
        $loc["__init__"] = PyDefUtils.funcFastCall((args, kwargs) => {
            const self = args[0];
            self._anvil.updateDesignName = updateDesignName;
            return PyDefUtils.pyCall(pyModule["DesignColumnPanel"].prototype["__init__"], args, kwargs);
        });
    }, 'DesignLink', [pyModule["Link"]]);

    const oldTextSet = pyModule["Link"].prototype._anvilClassic$propMap.text.set;
    const oldIconSet = pyModule["Link"].prototype._anvilClassic$propMap.icon.set;

    function updateDesignName(s) {
        const textProp = s._anvil.getPropJS("text");
        const iconProp = s._anvil.getPropJS("icon");
        const e = s._anvil.element.find(`div.${getCssPrefix()}link-text`);
        e.find(".anvil-designer-empty-component-message").remove();
        if (!s._anvil.inlineEditing && !textProp && !iconProp && (!s._anvil.components || !s._anvil.components.length)) {
            e.append($('<span class="anvil-designer-empty-component-message">').text(s._anvil.designName)); 
            e.first().css('display', 'inline-block');
        }
    }

    pyModule["DesignLink"].prototype._anvilClassic$propMap["text"].set = function(s,e,v) {
        oldTextSet(s,e,v);
        updateDesignName(s);
    };

    pyModule["DesignLink"].prototype._anvilClassic$propMap["icon"].set = function(s,e,v) {
        oldIconSet(s,e,v);
        updateDesignName(s);
    }

};
